import React from "react";
import Reveal from "./Reveal";
import { CLIENTS } from "../mock";

const statusColor = (s) => (s === "Live" ? "var(--green)" : s === "Onboarding" ? "var(--accent)" : "var(--ink-soft)");

export default function ClientWork() {
  return (
    <section id="work" style={{ padding: "72px 0" }}>
      <div className="container-x">
        <Reveal>
          <div className="section-label">Current work</div>
          <h2 className="h-section" style={{ marginTop: 18, maxWidth: 760 }}>
            Who we work with. <span className="serif" style={{ fontSize: "1.05em" }}>Named on request.</span>
          </h2>
          <p style={{ marginTop: 20, fontSize: 17, lineHeight: 1.6, color: "var(--ink-soft)", maxWidth: 620 }}>
            Client names are shared on a call, with their permission. Results go up once each campaign has a full
            quarter of data.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" style={{ marginTop: 44 }}>
          {CLIENTS.map((c, i) => (
            <Reveal key={c.mono} delay={(i % 3) * 80}>
              <div className="card-line" style={{ padding: "26px 24px", height: "100%", borderRadius: 4, display: "flex", flexDirection: "column" }}>
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-3">
                    <span className="mono" style={{ width: 44, height: 44, display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: 3, background: "var(--paper-2)", border: "1px solid var(--line)", fontSize: 14, fontWeight: 600 }}>{c.mono}</span>
                    <div>
                      <div style={{ fontSize: 16, fontWeight: 600 }}>{c.name}</div>
                      <div style={{ fontSize: 12.5, color: "var(--ink-soft)" }}>{c.place}</div>
                    </div>
                  </div>
                  <span className="flex items-center gap-1.5" style={{ fontSize: 11.5, fontWeight: 600, color: statusColor(c.status), textTransform: "uppercase", letterSpacing: "0.08em" }}>
                    {c.status === "Live" && <span className="livedot" style={{ width: 7, height: 7, borderRadius: 99, background: "var(--green)", display: "inline-block" }} />}
                    {c.status}
                  </span>
                </div>

                <div style={{ marginTop: 20, display: "flex", gap: 20 }}>
                  <div>
                    <div className="serif" style={{ fontSize: 20, color: "var(--ink)" }}>{c.a}</div>
                  </div>
                </div>
                <div style={{ marginTop: 4, fontSize: 13, color: "var(--ink-soft)" }}>{c.b}</div>

                <p style={{ marginTop: 16, fontSize: 14, lineHeight: 1.6, color: "var(--ink-soft)", flex: 1 }}>{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
